<template>
  <v-container fluid>
    <v-row class="flex-grow-1 px-4">
      <v-col>
        <RemotePaginatedList :headers="headers"
                             multi-sort
                             v-model="selectedItemIds"
                             data-url="aafb/package/"
                             data-key="packages"
                             :extra-filters="{'status': 1}"
                             :refresh-trigger.sync="innerRefreshTrigger"
                             :no-data-text="$t('package.no_package')"
                             v-bind="$attrs">
          <template v-slot:item.create_at="{value}">
            {{ $parseDate(value, 'yyyy-MM-dd HH:mm:ss') }}
          </template>
          <template v-slot:item.facility="{item}">
            {{ `${$parseDate(item.start_time, 'yyyy-MM-dd HH:mm')} - ${$parseDate(item.end_time, 'HH:mm')} ${item.item.name}` }}
          </template>
          <template v-slot:item.actions="{item}">
            <v-btn icon color="primary"
                   :to="{name: 'package-detail', params: {packageId: item.id}}">
              <v-icon>mdi-magnify</v-icon>
            </v-btn>
          </template>
        </RemotePaginatedList>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import {computed, onMounted, ref, watch} from '@vue/composition-api';
import RemotePaginatedList from "@/components/RemotePaginatedList";
import {DateTime} from "luxon";

export default {
  name: 'UserPackageList',
  components: {RemotePaginatedList},
  props: {
    refreshTrigger: Boolean,
  },
  setup(props, {root, emit}) {
    const innerRefreshTrigger = ref(false);
    const refresh = async function () {
      innerRefreshTrigger.value = true;
    };
    onMounted(() => {
      refresh();
    });

    watch(() => props.refreshTrigger, (newValue) => {
      if (newValue) {
        refresh();
        emit('update:refresh-trigger', false);
      }
    });

    // Data Table
    const headers = computed(() => [
      {text: root.$t('package.create_at'), value: 'create_at'},
      {text: root.$t('package.name'), value: 'type.name', sortable: false},
      {text: root.$t('package.price'), value: 'price', sortable: false},
      {text: '', value: 'actions', sortable: false},
    ]);
    const filterOptions = computed(()=> {
      return []
    });

    const selectedItemIds = ref([]);
    watch(() => selectedItemIds.value, (newValue) => {
      emit('input', newValue);
    });

    const editItem = function (item) {
      emit('edit', item);
    };

    return {
      filterOptions,
      innerRefreshTrigger,

      headers,
      selectedItemIds,

      editItem,

      DateTime,
    }
  }
}
</script>
